// Verified actions we're using

export const REGISTER = 'REGISTER';

export const APPEND_NEW_MESSAGE = 'APPEND_NEW_MESSAGE';

export const RECEIVE_PHOTO = 'RECEIVE_PHOTO';

export const RECIEVE_POSITION = 'RECIEVE_POSITION';

export const RECEIVE_TOKEN = 'RECEIVE_TOKEN';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const SAVE_REG_STATE = 'SAVE_REG_STATE';
export const CLEAR_REG_STATE = 'CLEAR_REG_STATE';
export const RECEIVE_SEARCH_LIST = 'RECEIVE_SEARCH_LIST';
export const RECIEVE_RESULTS = 'RECIEVE_RESULTS';
export const RECEIVE_PROFILE = 'RECEIVE_PROFILE';
export const SELECT_SHOPPABLE = 'SELECT_SHOPPABLE';
export const SELECT_SEARCH_TERM = 'SELECT_SEARCH_TERM';
export const IDENTITY_REQUEST = 'IDENTITY_REQUEST';
export const IDENTITY_ERROR = 'IDENTITY_ERROR';
export const IDENTITY_SUCCESS = 'IDENTITY_SUCCESS';
export const SHOW_GLOBAL_MESSAGE = 'SHOW_GLOBAL_MESSAGE';
export const CLOSE_GLOBAL_MESSAGE = 'CLOSE_GLOBAL_MESSAGE';
export const SHOW_SPINNER = 'SHOW_SPINNER';
export const HIDE_SPINNER = 'HIDE_SPINNER';
export const CHANGE_TAB = 'CHANGE_TAB';
export const CHANGE_PAGE_NAME = 'CHANGE_PAGE_NAME';
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_ERROR = 'REGISTER_ERROR';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';

export const PASSWORD_REQUEST = 'PASSWORD_REQUEST';
export const PASSWORD_ERROR = 'PASSWORD_ERROR';
export const PASSWORD_SUCCESS = 'PASSWORD_SUCCESS';
export const PASSWORD_COMPLETE = 'PASSWORD_COMPLETE';


export const RECIEVE_FACILITY = 'RECIEVE_FACILITY';
export const FACILITY_ERROR = 'FACILITY_ERROR';

export const ALERT_RESTART = 'ALERT_RESTART';
export const ALERT_REDOWNLOAD = 'ALERT_REDOWNLOAD';

export const FIX_MESSAGE = 'FIX_MESSAGE';
export const SAVE_MESSAGE = 'SAVE_MESSAGE';
export const NEXT_STEP = 'NEXT_STEP';
export const PREV_STEP = 'PREV_STEP';
export const RECIEVE_MESSAGES = 'RECIEVE_MESSAGES';
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const SELECT_MESSAGE = 'SELECT_MESSAGE';

export const HANDLE_CATEGORY_SELECT = 'HANDLE_CATEGORY_SELECT';

export const RECEIVE_INSURANCE_CARD = 'RECEIVE_INSURANCE_CARD';
export const RECEIVE_BENEFITS = 'RECEIVE_BENEFITS';
export const RECEIVE_INCENTIVES = 'RECEIVE_INCENTIVES';

export const RECEIVE_PLANS = 'RECEIVE_PLANS';

export const ACCOUNT_VERIFIED = 'ACCOUNT_VERIFIED';

export const INACTIVATE_APP = 'INACTIVATE_APP';

export const SIGA1 = 'SIGA1';
export const ADD_MESSAGE_REPLY = 'ADD_MESSAGE_REPLY';
export const INDICATE_NEW_MESSAGE = 'INDICATE_NEW_MESSAGE';
export const UPDATE_GLOBAL_NEW_MESSAGE_COUNT = 'UPDATE_GLOBAL_NEW_MESSAGE_COUNT';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const SHOW_MESSAGES = 'SHOW_MESSAGES';
export const RECEIVE_MESSAGE_REPLIES = 'RECEIVE_MESSAGE_REPLIES';
export const NEW_MESSAGE = 'NEW_MESSAGE';
export const SELECT_A_TOPIC = 'SELECT_A_TOPIC';
export const CLEAR_THE_DOT = 'CLEAR_THE_DOT';

export const SET_COST = 'SET_COST';
export const DELETE_MESSAGE_REPLY = 'DELETE_MESSAGE_REPLY';

export const CHANGE_STATUS = 'CHANGE_STATUS';
export const ADD_LOG_EVENT = 'ADD_LOG_EVENT';
export const SET_MIN_HEIGHT = 'SET_MIN_HEIGHT';
export const SET_DIMENSIONS = 'SET_DIMENSIONS';

// export const APPEND_LIKE = 'APPEND_LIKE';
// export const CHANGE_ACTIVE_PLAYLIST = 'CHANGE_ACTIVE_PLAYLIST';
// export const CHANGE_ACTIVE_SONG_ID = 'CHANGE_ACTIVE_SONG_ID';
// export const CHANGE_ACTIVE_USER_ID = 'CHANGE_ACTIVE_USER_ID';
// export const CHANGE_CURRENT_TIME = 'CHANGE_CURRENT_TIME';
// export const CHANGE_IS_MOBILE = 'CHANGE_IS_MOBILE';
// export const CHANGE_MODAL = 'CHANGE_MODAL';
// export const CHANGE_PATH = 'CHANGE_PATH';
// export const CHANGE_PLAYING_SONG = 'CHANGE_PLAYING_SONG';
// export const CHANGE_SELECTED_PLAYLISTS = 'CHANGE_SELECTED_PLAYLISTS';
 export const CHANGE_WIDTH_AND_HEIGHT = 'CHANGE_WIDTH_AND_HEIGHT';
// export const PLAY_SONG = 'PLAY_SONG';
// export const RECEIVE_ACCESS_TOKEN = 'RECEIVE_ACCESS_TOKEN';
// export const RECEIVE_AUTHED_FOLLOWINGS = 'RECEIVE_AUTHED_FOLLOWINGS';
// export const RECEIVE_AUTHED_PLAYLISTS = 'RECEIVE_AUTHED_PLAYLISTS';
// export const RECEIVE_AUTHED_USER = 'RECEIVE_AUTHED_USER';
// export const RECEIVE_LIKES = 'RECEIVE_LIKES';
// export const RECEIVE_SONG = 'RECEIVE_SONG';
// export const RECEIVE_SONG_COMMENTS = 'RECEIVE_SONG_COMMENTS';
// export const RECEIVE_SONGS = 'RECEIVE_SONGS';
// export const RECEIVE_NEW_STREAM_SONGS = 'RECEIVE_NEW_STREAM_SONGS';
// export const RECEIVE_USER = 'RECEIVE_USER';
// export const RECEIVE_USER_FOLLOWINGS = 'RECEIVE_USER_FOLLOWINGS';
// export const RECEIVE_USER_PROFILES = 'RECEIVE_USER_PROFILES';
// export const REMOVE_UNLIKED_SONGS = 'REMOVE_UNLIKED_SONGS';
// export const RESET_AUTHED = 'RESET_AUTHED';
// export const REQUEST_SONG = 'REQUEST_SONG';
// export const REQUEST_SONGS = 'REQUEST_SONGS';
// export const REQUEST_USER = 'REQUEST_USER';
// export const SET_FOLLOWING = 'SET_FOLLOWING';
// export const SET_LIKE = 'SET_LIKE';
// export const TOGGLE_IS_PLAYING = 'TOGGLE_IS_PLAYING';
// export const UNSHIFT_NEW_STREAM_SONGS = 'UNSHIFT_NEW_STREAM_SONGS';


// WEBPACK FOOTER //
// ./src/constants/actionTypes.js